module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module5-1.cee42fbe.jpg";